import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n";
import { CITIES } from "@/data/cities";

const slugFor = (name) => CITIES.find((c) => c.name === name)?.slug;

export const Marquee = () => {
  const { t } = useLanguage();
  const items = [...t.cities, ...t.cities];
  return (
    <div
      className="road-band relative overflow-hidden py-8"
      data-testid="cities-marquee"
    >
      {/* road edge lines */}
      <div className="absolute inset-x-0 top-2.5 h-[3px] bg-[#e8e6e1]/25 rounded-full" />
      <div className="absolute inset-x-0 bottom-2.5 h-[3px] bg-[#e8e6e1]/25 rounded-full" />
      {/* moving dashed center lane */}
      <div className="road-dashes" />

      {/* scrolling highway exit signs */}
      <div className="relative flex whitespace-nowrap animate-marquee-x w-max items-center marquee-track">
        {items.map((city, i) => {
          const slug = slugFor(city);
          const sign = (
            <span className="road-sign font-display">
              {city}
              <span className="road-sign-arrow" aria-hidden="true">→</span>
            </span>
          );
          return slug ? (
            <Link
              key={i}
              to={`/windshield-replacement-${slug}`}
              data-testid={`marquee-city-${slug}`}
              className="marquee-item flex items-center outline-none"
              tabIndex={-1}
            >
              {sign}
            </Link>
          ) : (
            <span key={i} className="marquee-item flex items-center">
              {sign}
            </span>
          );
        })}
      </div>

      {/* edge fades */}
      <div className="absolute inset-y-0 left-0 w-28 bg-gradient-to-r from-[#161616] to-transparent pointer-events-none z-10" />
      <div className="absolute inset-y-0 right-0 w-28 bg-gradient-to-l from-[#161616] to-transparent pointer-events-none z-10" />
    </div>
  );
};
